import React from 'react';
import { connect } from 'react-redux';

import { setNotePreview } from '../../../../../_actions/questionnaire.actions'

const person = { firstName: 'Lorraine', lastName: 'Simpson', age: 54, gender: 'female' };

const NotePreview = ({ noteTemplate = '', answers, dispatch }) => {
  if (noteTemplate) {

    noteTemplate = noteTemplate.replace(new RegExp('Q!FIRST_NAME\\b', 'g'), person.firstName);
    noteTemplate = noteTemplate.replace(new RegExp('Q!LAST_NAME\\b', 'g'), person.lastName);
    noteTemplate = noteTemplate.replace(new RegExp('Q!AGE\\b', 'g'), person.age);
    noteTemplate = noteTemplate.replace(new RegExp('Q!GENDER\\b', 'g'), person.gender);

    answers.forEach((answer) => {
      const answerString = Array.isArray(answer.answer) ? answer.answer.join(', ') : answer.answer;

      const regex = new RegExp(`Q!${answer.linkId}\\b`, 'g');

      noteTemplate = noteTemplate.replace(regex, answerString);
    });

    dispatch(setNotePreview(noteTemplate));
  }

  return (
    <div className="row">
      <div className="col-lg-12 mb-2">
        <h5 style={{ borderBottom: '4px solid #1AB2E9' }}>HPI Preview</h5>

        <div className="p-3" style={{ backgroundColor: '#fff', height: '19em', overflow: 'scroll' }}>
          {noteTemplate || ''}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    noteTemplate: state.questionnaire.noteTemplate,
    answers: state.questionnaire.answers
  }
}

export default connect(mapStateToProps)(NotePreview)